"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var styles = require('./MessageAdReadingPane.scss');
var classNames = require('classnames/bind').bind(styles);
var SubjectHeader = /** @class */ (function (_super) {
    tslib_1.__extends(SubjectHeader, _super);
    function SubjectHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubjectHeader.prototype.render = function () {
        var subjectDisplay = this.props.subject || owa_mail_strings_1.default.noSubjectText;
        return (React.createElement("div", { className: classNames(styles.subject, 'allowTextSelection'), title: this.props.subject },
            this.props.originalPrice && (React.createElement("span", { className: styles.originalPrice }, this.props.originalPrice)),
            this.props.currentPrice && React.createElement("span", null, this.props.currentPrice),
            subjectDisplay));
    };
    SubjectHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], SubjectHeader);
    return SubjectHeader;
}(React.Component));
exports.default = SubjectHeader;
//# sourceMappingURL=SubjectHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/components/SubjectHeader.js
// module id = 5561
// module chunks = 17